import React from 'react';

import { T } from 'react-translator-component';
import styled from 'styled-components';

import SupportConfigForm from '../organisms/SupportConfigForm';

const SupportPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0;

  h1 {
    font-size: 24px;
  }

  h2 {
    font-size: 18px;
  }
`;

const SupportPage = () => {
  const initialValues = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    subject: 'general',
    message: '',
  };

  return (
    <SupportPageWrapper>
      <h1>{T('Send us a message and we will get in touch')} =)</h1>

      <SupportConfigForm initialValues={initialValues} />
    </SupportPageWrapper>
  );
};

export default SupportPage;
